(function($){
    var qlInput = $('#query_leg');
    $("[name='query_leg']").on('click',function(e){
        qlInput.val($(e.target).val());
    });
    $('.simple-search-submit').on('click' ,function( e ){
        $(e.target).parent('form').submit();
    });
})(jQuery);
